import { publicConfig } from "@lululemon/ecom-core";

if (process.browser && process.env.NODE_ENV === "development") {
  publicConfig.proxyApiHost = publicConfig.apiHost;
  publicConfig.apiHost = `https://${publicConfig.host}`;
}

if (process.browser && process.env.NODE_ENV !== "development") {
  publicConfig.apiHost = `https://${window.location.host}`;
}

export { publicConfig };
